//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing
var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName("body")[0],
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

//resizeWindow();

// Func = limiting Scope for this file
(function () {
  window.onload = function () {
    resizeWindow();
    scrollW();
  };

  //header image to be window height on homepage
  if (document.getElementsByClassName("img-slide").length > 0) {
    let headerImages = document.getElementsByClassName("img-slide");
    let headerImagesLength = headerImages.length;
    for (let i = 0; i < headerImagesLength; i++) {
      headerImages[i].style.height = windowHeight + 10 + "px";
    }
  }

  //planning button click
  if (document.getElementsByClassName("planning-btn").length > 0) {
    let planningBtn = document.getElementsByClassName("planning-btn");
    for (let i = 0; i < planningBtn.length; i++) {
      planningBtn[i].addEventListener("click", function (e) {
        e.preventDefault();
        let formContainer = document.getElementsByClassName("planning-form");
        for (let i = 0; i < formContainer.length; i++) {
          const element = formContainer[i];
          if (element.classList.contains("hidden")) {
            element.classList.remove("hidden");
            element.classList.add("visible");
            this.textContent = "close";
          } else {
            element.classList.add("hidden");
            element.classList.remove("visible");
            this.textContent = "start planning";
          }
        }
      });
    }
  }

  window.addEventListener("scroll", function () {
    scrollW();
  });
  window.addEventListener("resize", function () {
    resizeWindow();
  });

  // scroll down click
  if (document.getElementsByClassName("scroll-down").length > 0) {
    document
      .getElementsByClassName("scroll-down")[0]
      .addEventListener("click", function () {
        animateTo("intro");
      });
  }

  function is_open(element) {
    let listItems = document.querySelectorAll(".privary-navigation__item");
    if (element.classList.contains("open")) {
      element.classList.remove("open");
    } else {
      element.classList.add("open");
    }
    listItems.forEach((item) => {
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      } else {
        item.classList.add("active");
      }
    });
  }
  // Mobile menu  functionality
  if (document.getElementById("burgerMenu")) {
    let burger = document.getElementById("burgerMenu");
    let navigation = document.querySelector(".mobile-navigation");
    if (document.querySelector(".close-btn")) {
      let closeBtn = document.querySelector(".close-btn");
      closeBtn.addEventListener("click", () => is_open(navigation));
    }

    burger.addEventListener("click", () => is_open(navigation));
  }
  // END Mobile menu  functionality

  if (document.getElementById("burgerMenu-tb")) {
    let burgerMenu_tb = document.getElementById("burgerMenu-tb");
    let navigation = document.querySelector(".privary-navigation");
    let closer = document.createElement("div");
    closer.textContent = "close";
    closer.classList.add("closer-tb");
    navigation.appendChild(closer);

    burgerMenu_tb.addEventListener("click", () => {
      is_open(navigation);
    });

    closer.addEventListener("click", () => {
      is_open(navigation);
    });
  }
})();

$(".fancybox").fancybox({
  padding: 0,
  scrolling: "auto",
  nextEffect: "fade",
  prevEffect: "fade",
  helpers: {
    title: {
      type: "inside",
    },
  },
});

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;

  if (st > 80 && !document.getElementById("gallery")) {
    if (!document.getElementById("header").classList.contains("internal")) {
      document.getElementById("header").classList.add("internal");
    }
  } else if (
    document.getElementById("gallery") ||
    document.querySelector(".sitemap") ||
    document.querySelector(".terms-and-conditions")
  ) {
    document.getElementById("header").classList.add("internal");
  } else {
    if (document.getElementById("header").classList.contains("internal")) {
      document.getElementById("header").classList.remove("internal");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow() {
  //calculate a new window size
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

  //header image to be window height on homepage
  if (document.getElementsByClassName("img-slide").length > 0) {
    let headerImages = document.getElementsByClassName("img-slide");
    let headerImagesLength = headerImages.length;
    for (let i = 0; i < headerImagesLength; i++) {
      headerImages[i].style.height = windowHeight + 10 + "px";
    }
  }
}

//animation of scroll vanilla JS
function animateTo(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 100;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var yH = easeInOutQuart(time, from, to - from, duration);
    } else {
      var yH = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, yH);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}

//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

// window offset
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// Rooms Filter
if (document.querySelectorAll(".first-filter-name")) {
  let items = document.querySelectorAll(".first-filter-name");
  let myRooms = document.querySelectorAll(".rooms-block__unit");
  applyFilter(items, myRooms);
}
function applyFilter(items, rooms) {
  items.forEach((item) => {
    item.addEventListener("click", () => {
      clearFilter(items, rooms);
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      } else {
        // console.log(item)
        showMyRoom(item.textContent.replaceAll(" ", "-"), rooms);
        item.classList.add("active");
      }
    });
  });
}
function showMyRoom(value, rooms) {
  rooms.forEach((room) => {
    if (value === "all") {
      room.classList.remove("hidden");
      room.classList.add("active");
    } else if (room.classList.contains(value)) {
      room.classList.remove("hidden");
    } else {
      room.classList.add("hidden");
    }
  });
}

function clearFilter(items, rooms) {
  items.forEach((item) => {
    item.classList.remove("active");
  });
}
// End Rooms Filter
